<template>
  <div class="appContainer entrance">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('entrance-page.header-update', { split: '/' }) }}</h1>
    </div>

    <v-row class="profile">
      <div class="wrapper-entry">
        <v-col cols="12" md="12" sm="12" lg="12">
          <table class="table-custom" border="0" cellspacing="0" cellpadding>
            <tbody>
              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('study_status')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.study-status', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  >
                  </label>

                  <span class="col-require title-right-style" v-if="isFieldRequired('study_status')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="study_status"
                      v-model="study_status"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('study_status')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_study_status"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[0].input_example
                          : getInputExample[0].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.study_status.$invalid &&
                        $v.study_status.$dirty &&
                        !$v.study_status.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('last_academic_history')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.last-academic-history', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>

                  <span class="col-require title-right-style" v-if="isFieldRequired('last_academic_history')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.last_academic_history.$invalid &&
                          $v.last_academic_history.$dirty
                      }"
                      rows="3"
                      v-model.trim="$v.last_academic_history.$model"
                      ref="last_academic_history"
                    ></textarea>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.last_academic_history.$invalid &&
                        $v.last_academic_history.$dirty &&
                        !$v.last_academic_history.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[1].input_example
                          : getInputExample[1].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('university_id')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.university', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('university_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="university_id"
                      v-model="university_id"
                      class="input select-option-style"
                      @change="onchangeUniversity"
                      :disabled="isFieldReadonly('university_id')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_university"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.university_id.$invalid &&
                        $v.university_id.$dirty &&
                        !$v.university_id.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                  <div
                    class="input-relative add-input-style"
                    v-if="
                      university_input_text_flag == 1 &&
                      isShowEntryInformationField('school_name')
                    "
                  >
                    <input
                      name="school_name"
                      type="text"
                      class="input textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.school_name.$invalid && $v.school_name.$dirty
                      }"
                      v-model.trim="$v.school_name.$model"
                      ref="school_name"
                    />
                    <span class="form-error-tip" v-show="requiredSchoolName">{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span>
                    <span
                      class="form-error-tip"
                      v-if="!$v.school_name.maxLength"
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale == LANG_CODE_JAPANESE
                        ? getInputExample[1].input_example
                        : getInputExample[1].input_example_vn
                    }}
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('faculty_id')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.faculty-id', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('faculty_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="faculty_id"
                      v-model="faculty_id"
                      class="input select-option-style"
                      @change="onchangeFaculty"
                      :disabled="isFieldReadonly('faculty_id')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_faculty"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.faculty_id.$invalid &&
                        $v.faculty_id.$dirty &&
                        !$v.faculty_id.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                  <div
                    class="input-relative add-input-style"
                    v-if="
                      faculty_input_text_flag == 1 &&
                      isShowEntryInformationField('faculty')
                    "
                  >
                    <input
                      name="faculty"
                      type="text"
                      class="input textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.faculty.$invalid && $v.faculty.$dirty
                      }"
                      v-model.trim="$v.faculty.$model"
                      ref="faculty"
                    />
                    <span class="form-error-tip" v-show="requiredFacultyName">{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span>
                    <span class="form-error-tip" v-if="!$v.faculty.maxLength">{{
                      $t('validate.out-of-range', {
                        split: '/'
                      })
                    }}</span>
                  </div>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale == LANG_CODE_JAPANESE
                        ? getInputExample[2].input_example
                        : getInputExample[2].input_example_vn
                    }}
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('graduation_month')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.graduate', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>

                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('graduation_month')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <div class="date-picker-relative">
                      <v-dialog
                        ref="modal_graduation_month"
                        v-model="modal_graduation_month"
                        :return-value.sync="graduation_month"
                        persistent
                        max-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-calendar
                          </v-icon>
                        </template>
                        <v-date-picker
                          v-model="graduation_month"
                          type="month"
                          :locale="getLocaleDatePicker()"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modal_graduation_month = false"
                            >{{
                              $t('component.btn-cancle', {
                                split: '/'
                              })
                            }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              $refs.modal_graduation_month.save(
                                graduation_month
                              )
                            "
                            >{{ $t('component.btn-ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-menu class="v-menu-custom">
                        <template
                          v-slot:activator="{ on, attrs }"
                          class="date-picker-relative"
                        >
                          <v-text-field
                            v-model="graduationMonthFormattedTextField"
                            persistent-hint
                            v-bind="attrs"
                            v-on="on"
                            @blur="handleGraduationMonthFromTextField"
                            class="input-date-picker"
                          ></v-text-field>
                        </template>
                      </v-menu>
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        !$v.graduationMonthFormattedTextField
                          .graduationMonthFormatted
                      "
                    >
                      {{
                        $t('validate.date-invalid', {
                          split: '/'
                        })
                      }}
                    </span>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[3].input_example
                          : getInputExample[3].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-status', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('work_status')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                  <!-- <span
class="col-require text-right title-right-style"
v-if="isShowEntryInformationField('work_status_text')"
>
{{
$t('profile-page.status.required', {
split: '/'
})
}}
</span> -->
                </td>
                <td class="td-right">
                  <div
                    class="input-relative"
                    v-if="isShowEntryInformationField('work_status')"
                  >
                    <div class="right-item edit-input-style">
                      <div class="input-relative">
                        <select
                          name="work_status"
                          v-model="work_status"
                          class="input select-option-style"
                          :disabled="isFieldReadonly('work_status')"
                        >
                          <option value="">
                            --
                            {{
                              $t('register-page.step-two.choose', {
                                split: '/'
                              })
                            }}
                            --
                          </option>
                          <option
                            v-bind:key="item.id"
                            v-for="item in c_work_status"
                            v-bind:value="item.id"
                          >
                            {{ item.name_convert }}
                          </option>
                        </select>
                        <div
                          class="input-example-style"
                          v-if="getInputExample.length !== 0"
                        >
                          {{
                            this.$i18n.locale == LANG_CODE_JAPANESE
                              ? getInputExample[4].input_example
                              : getInputExample[4].input_example_vn
                          }}
                        </div>
                      </div>
                      <span
                        class="form-error-tip"
                        v-show="requiredWorkStatus"
                        >{{
                          $t('validate.required', {
                            split: '/'
                          })
                        }}</span
                      >
                      <span
                        class="form-error-tip"
                        v-if="
                          $v.work_status.$invalid &&
                          $v.work_status.$dirty &&
                          !$v.work_status.required
                        "
                        >{{
                          $t('validate.required', {
                            split: '/'
                          })
                        }}</span
                      >
                    </div>
                  </div>
                  <div
                    class="input-relative"
                    v-if="isShowEntryInformationField('work_status_text')"
                  >
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.work_status_text.$invalid &&
                          $v.work_status_text.$dirty
                      }"
                      rows="8"
                      v-model.trim="$v.work_status_text.$model"
                      ref="work_status_text"
                    ></textarea>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.work_status_text.$invalid &&
                        $v.work_status_text.$dirty &&
                        !$v.work_status_text.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[2].input_example
                          : getInputExample[2].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus && isShowEntryInformationField('company_name')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.company-name', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('company_name')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="company_name"
                      type="text"
                      class="input textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.company_name.$invalid && $v.company_name.$dirty
                      }"
                      v-model.trim="$v.company_name.$model"
                      ref="company_name"
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[5].input_example
                          : getInputExample[5].input_example_vn
                      }}
                    </div>
                    <span class="form-error-tip" v-show="requiredCompanyName">{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span>
                    <span
                      class="form-error-tip"
                      v-if="!$v.company_name.maxLength"
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('industry_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.industry-type', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('industry_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="industry_type"
                      v-model="industry_type"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('industry_type')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_industry_type"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[6].input_example
                          : getInputExample[6].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-show="requiredIndustryType"
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('occupation_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.position', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('occupation_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="occupation_type"
                      v-model="occupation_type"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('occupation_type')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_occupation_type_no_group"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[7].input_example
                          : getInputExample[7].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-show="requiredOccupationType"
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('work_contract_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-contract-type', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('work_contract_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="work_contract_type"
                      v-model="work_contract_type"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('work_contract_type')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_work_contract_type"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[8].input_example
                          : getInputExample[8].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-show="requiredWorkContractType"
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkRetireWorkStatus &&
                  work_status !== '' &&
                  isShowEntryInformationField('resignation_month')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.resignation-month', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <div class="date-picker-relative">
                      <v-dialog
                        ref="dialog"
                        v-model="modal_resignation_month"
                        :return-value.sync="resignation_month"
                        persistent
                        max-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-calendar
                          </v-icon>
                        </template>

                        <v-date-picker
                          v-model="resignation_month"
                          :locale="getLocaleDatePicker()"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modal_resignation_month = false"
                            >{{
                              $t('component.btn-cancle', {
                                split: '/'
                              })
                            }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(resignation_month)"
                            >OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>

                      <v-menu class="v-menu-custom">
                        <template
                          v-slot:activator="{ on, attrs }"
                          class="date-picker-relative"
                        >
                          <v-text-field
                            v-model="resignationMonthFormattedTextField"
                            :hint="getHint"
                            persistent-hint
                            v-bind="attrs"
                            v-on="on"
                            @blur="handleResignationMonthFromTextField"
                            class="input-date-picker"
                          ></v-text-field>
                        </template>
                      </v-menu>
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        resignationMonthFormattedTextField !== '' &&
                        !$v.resignationMonthFormattedTextField
                          .resignationMonthFormatted
                      "
                    >
                      {{
                        $t('validate.date-invalid', {
                          split: '/'
                        })
                      }}
                    </span>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[9].input_example
                          : getInputExample[9].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('jlpt_level')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.japanese-level', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('jlpt_level')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="jlpt_level"
                      v-model="jlpt_level"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('jlpt_level')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_japanese_level"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[10].input_example
                          : getInputExample[10].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.jlpt_level.$invalid &&
                        $v.jlpt_level.$dirty &&
                        !$v.jlpt_level.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('english_level')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.english-level', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('english_level')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="english_level"
                      v-model="english_level"
                      class="input select-option-style"
                      :disabled="isFieldReadonly('english_level')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_english_level"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[11].input_example
                          : getInputExample[11].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.english_level.$invalid &&
                        $v.english_level.$dirty &&
                        !$v.english_level.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('toeic_score')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.toeic-score', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('toeic_score')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="toeic_score"
                      type="text"
                      class="input input-style"
                      v-bind:class="{
                        'error-validate':
                          $v.toeic_score.$invalid && $v.toeic_score.$dirty
                      }"
                      v-model.trim="$v.toeic_score.$model"
                      ref="toeic_score"
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[12].input_example
                          : getInputExample[12].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.toeic_score.$invalid &&
                        $v.toeic_score.$dirty &&
                        (!$v.toeic_score.numeric || !$v.toeic_score.between)
                      "
                      >{{
                        $t('validate.toeic-score-format', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.skill', {
                        split: '/'
                      })
                    "
                    v-if="isShowEntryInformationField('skill_type')"
                    class="title-left-style"
                  ></label>

                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.skill-text', {
                        split: '/'
                      })
                    "
                    v-if="isShowEntryInformationField('skill_name_text')"
                    class="title-left-style"
                  ></label>
                  <span
                    v-if="isShowEntryInformationField('skill_name_text')"
                    class="col-require text-right title-right-style"
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div
                    class="choose-skill"
                    v-if="isShowEntryInformationField('skill_type')"
                  >
                    <div class="input-relative">
                      <div
                        class="widget-skill mb-2"
                        v-for="(item, index) in skillArray"
                        :key="item.key"
                      >
                        <div class="box-skill">
                          <div class="form-select-skill">
                            <select v-model="skillArray[index].skillType">
                              <option value="">
                                --
                                {{
                                  $t('register-page.step-two.choose', {
                                    split: '/'
                                  })
                                }}
                                --
                              </option>
                              <option
                                v-bind:key="skill_type.id"
                                v-for="skill_type in m_skill_type"
                                v-bind:value="skill_type.skill_type_code"
                              >
                                {{ skill_type.name_convert }}
                              </option>
                            </select>
                          </div>

                          <div class="form-select-skill">
                            <select v-model="skillArray[index].skill">
                              <option
                                v-bind:key="skill.id"
                                v-for="skill in skills[index]"
                                v-bind:value="skill.id"
                              >
                                {{ skill.name_convert }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div
                          class="btn-add-group"
                          v-if="checkSizeObject(skillArray) - 1 == item.key"
                        >
                          <button
                            class="btn-add-skill"
                            v-on:click="handleAddSkill"
                            v-if="
                              checkSizeObject(skillArray) - 1 == item.key &&
                              countSkill <= 9
                            "
                          >
                            <v-icon>mdi-plus</v-icon>
                          </button>

                          <button
                            class="btn-add-skill"
                            v-on:click="handleDeleteSkill"
                            v-if="
                              checkSizeObject(skillArray) - 1 == item.key &&
                              item.key !== 0
                            "
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </button>
                        </div>
                      </div>
                      <div
                        class="input-example-style"
                        v-if="getInputExample.length !== 0"
                      >
                        {{
                          this.$i18n.locale == LANG_CODE_JAPANESE
                            ? getInputExample[13].input_example
                            : getInputExample[13].input_example_vn
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="input-relative"
                    v-if="isShowEntryInformationField('skill_name_text')"
                  >
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.skill_name_text.$invalid &&
                          $v.skill_name_text.$dirty
                      }"
                      rows="3"
                      v-model.trim="$v.skill_name_text.$model"
                      ref="skill_name_text"
                    ></textarea>

                    <span
                      class="form-error-tip"
                      v-if="
                        $v.skill_name_text.$invalid &&
                        $v.skill_name_text.$dirty &&
                        !$v.skill_name_text.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <span
                      class="form-error-tip"
                      v-if="!$v.skill_name_text.maxLength"
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[3].input_example
                          : getInputExample[3].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.desired-job', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('expect_occupation_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div
                    class="input-relative"
                    v-if="isShowEntryInformationField('expect_occupation_type')"
                  >
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.expect_occupation_type.$invalid &&
                        $v.expect_occupation_type.$dirty &&
                        !$v.expect_occupation_type.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div class="choose-skill">
                      <div
                        class="widget-checkbox mb-2"
                        v-for="(category, key) in m_occupation_type"
                        :key="key"
                      >
                        <label for=""
                          >- {{ category[0].occupation_category }}:</label
                        >
                        <div class="tree-checkbox">
                          <div
                            class="checkbox-item"
                            v-for="(item, index) in category"
                            :key="index"
                          >
                            <input
                              type="checkbox"
                              v-model="expect_occupation_type"
                              :value="item.id"
                            />
                            {{ item.name_convert }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="input-relative"
                    v-if="
                      isShowEntryInformationField('expect_occupation_type_text')
                    "
                  >
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.expect_occupation_type_text.$invalid &&
                          $v.expect_occupation_type_text.$dirty
                      }"
                      rows="3"
                      v-model.trim="$v.expect_occupation_type_text.$model"
                      ref="expect_occupation_type_text"
                    ></textarea>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.expect_occupation_type_text.$invalid &&
                        $v.expect_occupation_type_text.$dirty &&
                        !$v.expect_occupation_type_text.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[4].input_example
                          : getInputExample[4].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('expected_requirements')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.expected-requirements', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('expected_requirements')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.expected_requirements.$invalid &&
                          $v.expected_requirements.$dirty
                      }"
                      rows="5"
                      v-model.trim="$v.expected_requirements.$model"
                      ref="expected_requirements"
                    ></textarea>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.expected_requirements.$invalid &&
                        $v.expected_requirements.$dirty &&
                        !$v.expected_requirements.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[5].input_example
                          : getInputExample[5].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('expected_pay')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.expected-pay', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>

                  <span
                    class="col-require text-right title-right-style"
                    v-if="isShowEntryInformationField('work_status_text') || isFieldRequired('expected_pay')"
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.expected_pay.$invalid && $v.expected_pay.$dirty
                      }"
                      rows="5"
                      v-model.trim="$v.expected_pay.$model"
                      ref="expected_pay"
                    ></textarea>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.expected_pay.$invalid &&
                        $v.expected_pay.$dirty &&
                        !$v.expected_pay.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[6].input_example
                          : getInputExample[6].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('any_additional_comments')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.any-additional-comments', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <textarea
                      placeholder=""
                      v-bind:class="{
                        'text-area': true,
                        'textarea-input': true,
                        'error-validate':
                          $v.any_additional_comments.$invalid &&
                          $v.any_additional_comments.$dirty
                      }"
                      rows="3"
                      v-model.trim="$v.any_additional_comments.$model"
                      ref="any_additional_comments"
                    ></textarea>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[7].input_example
                          : getInputExample[7].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('work_location')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-locate', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require title-right-style" v-if="isFieldRequired('work_location')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="work_location"
                      v-model="work_location"
                      class="input select-option-style"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_work_location_applicant"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale == LANG_CODE_JAPANESE
                          ? getInputExample[14] !== undefined
                            ? getInputExample[14].input_example
                            : getInputExample[0].input_example
                          : getInputExample[14] !== undefined
                          ? getInputExample[14].input_example_vn
                          : getInputExample[0].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.work_location.$invalid &&
                        $v.work_location.$dirty &&
                        !$v.work_location.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>
              <tr class="tr-response">
                <!-- feature #248-->
                <td class="td-left">
                  <div class="div-left">
                    <div class="col-title">
                      {{
                        $t('entrance-page.self_promotion', {
                          split: '/'
                        })
                      }}
                    </div>
                  </div>
                </td>
                <td class="td-right">
                  <div class="div-right">
                    <div class="input-relative">
                      {{
                        $t('entrance-page.self_promotion_caption', {
                          split: '/'
                        })
                      }}
                      <textarea
                        class="text-area textarea-input"
                        v-bind:class="{
                          input: !$v.self_promotion.$invalid,
                          'input-style': !$v.self_promotion.$invalid,
                          'error-validate':
                            $v.self_promotion.$invalid &&
                            $v.self_promotion.$dirty
                        }"
                        rows="5"
                        v-model.trim="$v.self_promotion.$model"
                        ref="self_promotion"
                      ></textarea>
                      <span
                        class="form-error-tip"
                        v-if="
                          $v.self_promotion.$invalid && $v.self_promotion.$dirty
                        "
                        >{{
                          $t('validate.required', {
                            split: '/'
                          })
                        }}</span
                      >
                      <span
                        class="form-error-tip"
                        v-if="!$v.self_promotion.maxLength"
                        >{{
                          $t('validate.out-of-range', {
                            split: '/'
                          })
                        }}</span
                      >
                    </div>
                  </div>
                </td>
              </tr>
              <!-- end feature #248-->
            </tbody>
          </table>
        </v-col>
      </div>
    </v-row>

    <v-row>
      <v-col class="text-center btn-widget">
        <v-btn
          depressed
          class="btn-cancer"
          outlined
          color="#e8320e"
          @click="closeUpdate"
          >{{ $t('component.button-cancer', { split: '/' }) }}
        </v-btn>

        <v-btn
          class="btn-update ml-2"
          depressed
          color="#E8320D"
          @click="handleShowDetail"
          >{{ $t('component.button-update', { split: '/' }) }}
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="520">
      <v-card class="dialog-container">
        <v-icon color="#E8320D" class="close-icon" @click="handleCloseDialog"
          >{{ closeIcon }}
        </v-icon>
        <div class="dialog">
          <h4 v-html="$t('header.confirm-update', { split: '/' })"></h4>
          <v-card-actions>
            <v-btn
              class="btn-logout"
              depressed
              color="#e8320e"
              @click="updateEvent"
              :loading="btnLoading"
            >
              <!-- <router-link tag="span" :to="pathDefault"> -->
              {{ $t('header.btn-confirm', { split: '/' }) }}
              <!-- </router-link> -->
            </v-btn>

            <v-btn
              @click="handleCloseDialog"
              outlined
              color="#e8320e"
              class="btn-cancerDialog"
            >
              {{ $t('header.btn-cancer', { split: '/' }) }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  between,
  maxLength,
  numeric,
  required
} from 'vuelidate/lib/validators';
import './entrance.scss';
import { masterMixin } from '@/mixins/masterMixin.js';
import {
  EVENT_DEFAULT,
  LANG_CODE_JAPANESE,
  LANG_CODE_VIETNAMESE,
  LANG_JAPANESE,
  LANG_VIETNAMESE,
  WORK_STATUS_YES
} from '@/common/constants';
import { dateFormated, monthFormated } from '@/validators/date';
import { mdiClose } from '@mdi/js';

export default {
  mixins: [masterMixin],

  data: (vm) => {
    return {
      EVENT_DEFAULT,
      closeIcon: mdiClose,
      dialog: false,
      study_status: '',
      university_id: '',
      old_university_id: '',
      school_name: '',
      old_school_name: '',
      university_input_text_flag: '',
      requiredSchoolName: false,
      faculty_id: '',
      old_faculty_id: '',
      faculty: '',
      old_faculty: '',
      faculty_input_text_flag: '',
      requiredFacultyName: false,
      graduation_month: '',
      graduationMonthFormattedTextField: '',
      work_status: '',
      company_name: '',
      industry_type: '',
      work_contract_type: '',
      resignation_month: '',
      resignationMonthFormattedTextField: '',
      jlpt_level: '',
      english_level: '',
      toeic_score: '',
      skill_type: '',
      expect_occupation_type: [],
      work_location: '',
      self_promotion: '',
      occupation_type: '',
      btnLoading: false,
      modal_graduation_month: false,
      modal_resignation_month: false,
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      locale: 'vi',

      skillArray: {
        skill0: {
          key: 0,
          skillType: '',
          skills: [],
          skill: ''
        },
        skill1: {
          key: 1,
          skillType: '',
          skills: [],
          skill: ''
        },
        skill2: {
          key: 2,
          skillType: '',
          skills: [],
          skill: ''
        }
      },

      skills: {},
      countSkill: 0,
      disabled: true,

      last_academic_history: '',
      work_status_text: '',
      skill_name_text: '',
      expect_occupation_type_text: '',
      expected_requirements: '',
      expected_pay: '',
      any_additional_comments: '',

      checkWorkStatusToDisplay: false,

      requiredCompanyName: false,
      requiredIndustryType: false,
      requiredWorkContractType: false,
      requiredOccupationType: false,
      requiredWorkStatus: false,

      checkRetireWorkStatus: false
    };
  },

  validations() {
    const createDynamicValidations = () => {
      const schoolNameValidation =
        this.university_input_text_flag == 1
          ? {
              required,
              maxLength: maxLength(50)
            }
          : {
              maxLength: maxLength(50)
            };
      const facultyNameValidation =
        this.faculty_input_text_flag == 1
          ? {
              required,
              maxLength: maxLength(50)
            }
          : {
              maxLength: maxLength(50)
            };

      let baseValidations = {};

      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        baseValidations = {
          study_status: {
            required
          },
          university_id: {
            required
          },
          school_name: schoolNameValidation,
          faculty_id: {
            required
          },
          faculty: facultyNameValidation,
          graduation_month: {
            required
          },
          graduationMonthFormattedTextField: {
            graduationMonthFormatted: monthFormated(
              'graduationMonthFormattedTextField'
            )
          },
          resignationMonthFormattedTextField: {
            resignationMonthFormatted: dateFormated(
              'resignationMonthFormattedTextField'
            )
          },
          work_status: {
            required
          },
          company_name: {
            maxLength: maxLength(50)
          },
          industry_type: {},
          occupation_type: {},
          work_contract_type: {},
          resignation_month: {},
          jlpt_level: {
            required
          },
          english_level: {
            required
          },
          toeic_score: {
            numeric,
            between: between(0, 990)
          },
          expect_occupation_type: {
            required
          },
          work_location: {
            required
          },
          self_promotion: {
            maxLength: maxLength(500)
          }
        };
      } else {
        baseValidations = {
          last_academic_history: {
            required
          },
          work_status_text: {
            required
          },
          skill_name_text: {
            required,
            maxLength: maxLength(255)
          },
          expect_occupation_type_text: {
            required
          },
          expected_requirements: {
            required
          },
          expected_pay: {
            required
          },
          any_additional_comments: {},
          work_location: {
            required
          }
        };
      }

      // Apply form modifications only if they exist
      if (this.m_event && this.m_event.modify_fields) {
        Object.keys(baseValidations).forEach((fieldName) => {
          const modification = this.m_event.modify_fields.find(
            (mod) => mod.name === fieldName
          );
          // Handle required property modifications
          if (modification && modification.hasOwnProperty('required')) {
            if (modification.required === false) {
              delete baseValidations[fieldName].required;
            } else if (
              modification.required === true &&
              !baseValidations[fieldName].required
            ) {
              // Add required validation if not already present
              baseValidations[fieldName].required = required;
            }
          }

          // Handle type property modifications - convert numeric fields to text
          if (modification &&
              modification.type === 'text' &&
              baseValidations[fieldName].hasOwnProperty('numeric')) {
            // Remove numeric and between validators for text type fields
            delete baseValidations[fieldName].numeric;
            delete baseValidations[fieldName].between;
          }
        });
      }

      return baseValidations;
    };

    return createDynamicValidations();
  },

  computed: {
    ...mapGetters({
      m_template: 'getMTemplate',
      m_event: 'getEventData',
      applicant_entry: 'getEntryInfomation',
      c_japanese_level: 'getCJapaneseLevel',
      c_english_level: 'getCEnglishLevel',
      c_work_contract_type: 'getCWorkContractType',
      m_skill_type: 'getMSkillType',
      m_skill: 'getMSkill',
      m_work_location_applicant: 'getMWorkLocationApplicant',
      m_occupation_type: 'getMOccupationType',
      m_industry_type: 'getMIndustryType',
      current_lang: 'getCurrentLanguage',
      langInStore: 'getLang',
      m_input_example: 'getInputExample'
    }),

    graduationMonthFormatted() {
      return this.formatMonth(this.graduation_month);
    },

    resignationMonthFormatted() {
      return this.formatDate(this.resignation_month);
    },

    ...mapState({
      updateEntryInformationStatus: 'updateEntryInformationStatus'
    }),

    getMaxDate() {
      return new Date().toJSON();
    },

    checkWorkStatus() {
      return this.work_status == WORK_STATUS_YES;
    },

    getInputExample() {
      return this.m_input_example.filter((el) => el.screen_id == 2);
    }
  },

  watch: {
    resignation_month: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (datetime !== '' || datetime == null) {
          if (this.$i18n.locale == LANG_CODE_JAPANESE) {
            const [year, month, day] = datetime.split('-');
            string = year + '/' + month + '/' + day;
          } else {
            const [year, month, day] = datetime.split('-');
            string = day + '/' + month + '/' + year;
          }
          this.resignationMonthFormattedTextField = string;
        }
      }
    },

    graduation_month: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (this.$i18n.locale == LANG_CODE_JAPANESE) {
          const [year, month] = datetime.split('-');
          string = year + '/' + month;
        } else {
          const [year, month] = datetime.split('-');
          string = month + '/' + year;
        }
        this.graduationMonthFormattedTextField = string;
      }
    },
    '$i18n.locale': function (val, oldVal) {
      const resignationMonth = this.resignation_month;
      if (val !== oldVal) {
        if (resignationMonth !== null && resignationMonth !== '') {
          let stringResignationMonth = '';
          if (resignationMonth !== '') {
            if (this.$i18n.locale == LANG_CODE_JAPANESE) {
              const [year, month, day] = resignationMonth.split('-');
              stringResignationMonth = year + '/' + month + '/' + day;
            } else {
              const [year, month, day] = resignationMonth.split('-');
              stringResignationMonth = day + '/' + month + '/' + year;
            }
          }
          this.resignationMonthFormattedTextField = stringResignationMonth;
        }

        if (this.graduation_month !== null) {
          let stringGraduationMonth = '';
          const graduationMonth = this.graduation_month;
          if (this.$i18n.locale == LANG_CODE_JAPANESE) {
            const [year, month] = graduationMonth.split('-');
            stringGraduationMonth = year + '/' + month;
          } else {
            const [year, month] = graduationMonth.split('-');
            stringGraduationMonth = month + '/' + year;
          }
          this.graduationMonthFormattedTextField = stringGraduationMonth;
        }
      }
    },

    applicant_entry: function (val) {
      const {
        study_status,
        university_id,
        school_name,
        faculty_id,
        faculty,
        work_status,
        company_name,
        industry_type,
        occupation_type,
        work_contract_type,
        graduation_month,
        jlpt_level,
        english_level,
        toeic_score,
        skill_type,
        expect_occupation_type,
        last_academic_history,
        work_status_text,
        skill_name_text,
        expect_occupation_type_text,
        expected_requirements,
        expected_pay,
        any_additional_comments,
        work_location,
        self_promotion
      } = val;

      const skills = JSON.parse(skill_type);

      let occupationTypeConvert =
        occupation_type !== null ? JSON.parse(occupation_type) : '';

      if (typeof occupationTypeConvert == 'object') {
        occupationTypeConvert = occupationTypeConvert[0];
      }

      const expectOccupationTypeConvert =
        expect_occupation_type !== null
          ? JSON.parse(expect_occupation_type)
          : [];

      return [
        (this.study_status = study_status),
        (this.university_id = university_id),
        (this.school_name = school_name),
        (this.faculty_id = faculty_id),
        (this.faculty = faculty),
        (this.work_status = work_status),
        (this.company_name = company_name),
        (this.industry_type = industry_type),
        (this.occupation_type = occupationTypeConvert[0]),
        (this.work_contract_type = work_contract_type),
        (this.graduation_month = graduation_month),
        (this.jlpt_level = jlpt_level),
        (this.english_level = english_level),
        (this.toeic_score = toeic_score),
        (this.expect_occupation_type = expectOccupationTypeConvert),
        (this.work_location = work_location),
        (this.skill_type = JSON.parse(skill_type)),
        (this.occupation_type = occupationTypeConvert),
        (this.skillArray =
          skills !== null ? this.returnSkillArray(skills) : ''),
        (this.last_academic_history = last_academic_history),
        (this.work_status_text = work_status_text),
        (this.skill_name_text = skill_name_text),
        (this.expect_occupation_type_text = expect_occupation_type_text),
        (this.expected_requirements = expected_requirements),
        (this.expected_pay = expected_pay),
        (this.any_additional_comments = any_additional_comments),
        (this.self_promotion = self_promotion)
      ];
    },

    study_status: function () {
      // this.$v.$touch();
    },

    skills: function (val) {
      return val;
    },

    skillArray: {
      handler(val) {
        if (val) {
          const skills = {};
          let count = 0;
          Object.keys(this.skillArray).map((key, index) => {
            const nameSkill = 'skill' + index;
            let skill = {};
            if (this.skillArray[key].skillType !== '') {
              const skillFiltered = this.dataFiltered(
                this.skillArray[key].skillType
              );
              skill = Object.assign({}, skillFiltered);
            } else {
              this.skillArray[key].skill = '';
              skill = Object.assign({}, { key, skill_type: '', skill: '' });
            }
            count++;
            skills[nameSkill] = skill;
          });

          this.countSkill = count;
          if (this.countSkill == 0) {
            this.countSkill = 1;
            this.handleAddSkill();
          }

          return (this.skills = Object.assign({}, skills));
        }
      },
      deep: true
    },

    updateEntryInformationStatus: function (val, oldVal) {
      if (val !== oldVal && val == true) {
        this.$emit('updateEvent');
        this.btnLoading = false;
        this.resetStatusUpdateEntryInformation();
      }
    },

    work_status: function (val) {
      if (val == WORK_STATUS_YES) {
        this.checkRetireWorkStatus = true;
        this.checkWorkStatusToDisplay = true;
      } else {
        this.checkRetireWorkStatus = false;
        this.checkWorkStatusToDisplay = false;
        this.industry_type = '';
        this.occupation_type = '';
        this.company_name = '';
        this.work_contract_type = '';
      }
    },

    industry_type: function (val) {
      if (val !== '') {
        this.requiredIndustryType = false;
      }
    },

    occupation_type: function (val) {
      if (val !== '') {
        this.requiredOccupationType = false;
      }
    },

    company_name: function (val) {
      if (val !== '') {
        this.requiredCompanyName = false;
      }
    },

    work_contract_type: function (val) {
      if (val !== '') {
        this.requiredWorkContractType = false;
      }
    },

    school_name: function (val) {
      if (val !== '') {
        this.requiredSchoolName = false;
      }
    },

    faculty: function (val) {
      if (val !== '') {
        this.requiredFacultyName = false;
      }
    }
  },

  created() {
    const {
      study_status,
      university_id,
      school_name,
      faculty_id,
      faculty,
      work_status,
      company_name,
      industry_type,
      occupation_type,
      work_contract_type,
      graduation_month,
      resignation_month,
      jlpt_level,
      english_level,
      toeic_score,
      skill_type,
      expect_occupation_type,
      last_academic_history,
      work_status_text,
      skill_name_text,
      expect_occupation_type_text,
      expected_requirements,
      expected_pay,
      any_additional_comments,
      work_location,
      self_promotion
    } = this.applicant_entry;

    const skills = JSON.parse(skill_type);

    const occupationTypeConvert =
      occupation_type !== null ? JSON.parse(occupation_type) : '';

    const expectOccupationTypeConvert =
      expect_occupation_type !== null ? JSON.parse(expect_occupation_type) : [];

    // Load applicant data
    this.study_status = study_status;
    this.university_id = university_id;
    this.old_university_id = university_id;
    this.school_name = school_name;
    this.old_school_name = school_name;
    this.university_input_text_flag = this.getUniversityInputFlag(university_id);
    this.faculty_id = faculty_id;
    this.old_faculty_id = faculty_id;
    this.faculty = faculty;
    this.old_faculty = faculty;
    this.faculty_input_text_flag = this.getFacultyInputFlag(faculty_id);
    this.work_status = work_status !== null ? work_status : '';
    this.company_name = company_name;
    this.industry_type = industry_type;
    this.occupation_type = occupationTypeConvert[0];
    this.work_contract_type = work_contract_type;
    this.graduation_month = graduation_month;
    this.resignation_month = resignation_month;
    this.jlpt_level = jlpt_level;
    this.english_level = english_level;
    this.toeic_score = toeic_score;
    this.work_location = work_location;
    this.skill_type = JSON.parse(skill_type);
    this.expect_occupation_type = expectOccupationTypeConvert;
    this.skillArray = skills !== null ? this.returnSkillArray(skills) : '';
    this.last_academic_history = last_academic_history;
    this.work_status_text = work_status_text;
    this.skill_name_text = skill_name_text;
    this.expect_occupation_type_text = expect_occupation_type_text;
    this.expected_requirements = expected_requirements;
    this.expected_pay = expected_pay;
    this.any_additional_comments = any_additional_comments;
    this.self_promotion = self_promotion;

    // Load default values from m_event.modify_fields if no existing data
    if (this.m_event && this.m_event.modify_fields) {
      this.m_event.modify_fields.forEach((field) => {
        if (field.default_value && this.hasOwnProperty(field.name) && !this[field.name]) {
          this[field.name] = field.default_value;
        }
      });
    }
  },

  destroyed() {
    return [
      (this.study_status = ''),
      (this.university_id = ''),
      (this.school_name = ''),
      (this.faculty_id = ''),
      (this.faculty = ''),
      (this.work_status = ''),
      (this.company_name = ''),
      (this.self_promotion = ''),
      (this.checkRetireWorkStatus = false)
    ];
  },

  methods: {
    handleResignationMonthFromTextField() {
      let string = '';
      const datetime = this.resignationMonthFormattedTextField;
      if (this.checkDateFormate(datetime)) {
        if (this.$i18n.locale == LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        } else {
          const [day, month, year] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        }
        this.resignation_month = string;
      } else {
        this.resignation_month = '';
      }
    },

    /**
     * Sự kiện blur input để lưu lại ngày tháng đã nhập(graduation_month)
     */
    handleGraduationMonthFromTextField() {
      let string = '';
      const datetime = this.graduationMonthFormattedTextField;
      if (this.checkMonthFormate(datetime)) {
        if (this.$i18n.locale == LANG_CODE_JAPANESE) {
          const [year, month] = datetime.split('/');
          string = year + '-' + month;
        } else {
          const [month, year] = datetime.split('/');
          string = year + '-' + month;
        }
        this.graduation_month = string;
      }
    },

    handleShowDetail() {
      this.checkValidSchoolName();
      this.checkValidFacultyName();
      this.validateWorkStatus();
      this.$v.$touch();
      if (
        !this.$v.$error &&
        this.validateWorkStatus() &&
        this.checkUniversity() &&
        this.checkFaculty()
      ) {
        this.dialog = true;
      }
    },
    handleCloseDialog() {
      this.dialog = false;
    },
    getSkillTypeCodeFromSkill(id) {
      const filtered = this.m_skill.filter((skill) => skill.id == id);

      if (filtered.length > 0) {
        return filtered[0].skill_type_code;
      }
      return '';
    },

    returnSkillArray(skills) {
      const skillArray = {};

      skills.map((skill, index) => {
        const name = 'skill' + index;
        const obj = {};

        obj.key = index;
        obj.skillType = this.getSkillTypeCodeFromSkill(skill);
        obj.skill = skill;

        skillArray[name] = obj;
      });

      return skillArray;
    },

    updateEvent() {
      this.$v.$touch();
      this.btnLoading = true;
      this.validateWorkStatus();
      if (
        !this.$v.$error &&
        this.validateWorkStatus() &&
        this.checkUniversity() &&
        this.checkFaculty()
      ) {
        const {
          study_status,
          university_id,
          school_name,
          faculty_id,
          faculty,
          graduation_month,
          work_status,
          company_name,
          industry_type,
          occupation_type,
          work_contract_type,
          resignation_month,
          jlpt_level,
          english_level,
          toeic_score,
          expect_occupation_type,
          work_location,
          last_academic_history,
          work_status_text,
          skill_name_text,
          expect_occupation_type_text,
          expected_requirements,
          expected_pay,
          any_additional_comments,
          university_input_text_flag,
          faculty_input_text_flag,
          self_promotion
        } = this;

        const arrSkillID = this.getSkillArray();

        const arrOccupationType = [];
        arrOccupationType.push(occupation_type);

        const data = {
          study_status,
          university_id,
          school_name: this.convertStr(school_name),
          faculty_id,
          faculty: this.convertStr(faculty),
          graduation_month,
          work_status,
          company_name:
            work_status !== '' ? this.convertStr(company_name) : null,
          industry_type: work_status !== '' ? industry_type : null,
          occupation_type: arrOccupationType,
          work_contract_type: work_status !== '' ? work_contract_type : null,
          resignation_month,
          jlpt_level,
          english_level,
          toeic_score,
          skill_type: arrSkillID,
          expect_occupation_type,
          work_location,
          last_academic_history,
          work_status_text,
          skill_name_text,
          expect_occupation_type_text,
          expected_requirements,
          expected_pay,
          any_additional_comments,
          university_input_text_flag,
          faculty_input_text_flag,
          self_promotion
        };

        console.log(data);

        data.lang =
          this.langInStore == LANG_CODE_VIETNAMESE
            ? LANG_VIETNAMESE
            : LANG_JAPANESE;
        this.$store.dispatch('updateEntryInformation', { data });
      }
    },

    closeUpdate() {
      this.$emit('updateEvent');
    },

    ...mapMutations({
      resetStatusUpdateEntryInformation: 'UPDATE_ENTRY_INFORMATION_ERROR'
    }),

    checkSizeObject(obj = {}) {
      let size = 0;

      Object.keys(obj).map(() => {
        size++;
      });
      return size;
    },

    handleAddSkill() {
      if (this.countSkill < 10) {
        const skillArray = this.skillArray;
        const nameObj = 'skill' + this.checkSizeObject(skillArray);
        const skillAdd = {
          key: this.checkSizeObject(skillArray),
          skillType: '',
          skill: ''
        };

        skillArray[nameObj] = skillAdd;

        return (this.skillArray = Object.assign({}, skillArray));
      }
    },

    handleDeleteSkill() {
      const skillArray = this.skillArray;
      const objDelete = 'skill' + (this.checkSizeObject(skillArray) - 1);

      delete skillArray[objDelete];

      return (this.skillArray = Object.assign({}, skillArray));
    },

    dataFiltered(skill_type_code) {
      let arr = [];

      arr = this.m_skill.filter(
        (ele) => ele.skill_type_code == skill_type_code
      );

      return arr;
    },

    getSkillArray() {
      const skillArray = this.skillArray;

      const arrSkillID = [];
      Object.keys(skillArray).map((key) => {
        const id = skillArray[key].skill;
        if (id !== '') {
          arrSkillID.push(id);
        }
      });

      return arrSkillID;
    },

    studyStatusFormat: function () {
      const arr = this.c_study_status.filter(
        (ele) => ele.id == this.study_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    occupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter(
        (ele) => ele.id == this.occupation_type[0]
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    expectOccupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter((ele) => {
        if (this.expect_occupation_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    skillTypeFormat: function () {
      const arr = this.m_skill.filter((ele) => {
        if (this.skill_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    workStatusFormat: function () {
      const arr = this.c_work_status.filter(
        (ele) => ele.id == this.work_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    universityIdFormat: function () {
      if (this.university_id == '0' || this.university_id == null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? 'その他の / Other'
          : 'Khác';
      } else {
        const arr = this.m_university.filter(
          (ele) => ele.id == this.university_id
        );
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    facultyIdFormat: function () {
      if (this.faculty_id == '0' || this.faculty_id == null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? 'その他の / Other'
          : 'Khác';
      } else {
        const arr = this.m_faculty.filter((ele) => ele.id == this.faculty_id);
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    workContractFormat: function () {
      const arr = this.c_work_contract_type.filter(
        (ele) => ele.id == this.work_contract_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    japanLevelFormat: function () {
      const arr = this.c_japanese_level.filter(
        (ele) => ele.id == this.jlpt_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    englishLevelFormat: function () {
      const arr = this.c_english_level.filter(
        (ele) => ele.id == this.english_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workLocationFormat: function () {
      const arr = this.m_work_location_applicant.filter(
        (ele) => ele.id == this.work_location
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    checkUniversity() {
      return !(this.university_id == '0' && this.school_name == '');
    },

    checkFaculty() {
      return !(this.faculty_id == '0' && this.faculty == '');
    },

    validateWorkStatus() {
      if (this.work_status == '' || this.work_status == null) {
        this.requiredWorkStatus = true;
        return false;
      } else {
        this.requiredWorkStatus = false;
        if (this.work_status == WORK_STATUS_YES) {
          if (this.company_name == '' || this.company_name == null) {
            this.requiredCompanyName = true;
          }
          if (this.industry_type == '' || this.industry_type == null) {
            this.requiredIndustryType = true;
          }
          if (
            this.work_contract_type == '' ||
            this.work_contract_type == null
          ) {
            this.requiredWorkContractType = true;
          }
          if (this.occupation_type == '' || this.occupation_type == null) {
            this.requiredOccupationType = true;
          }

          return (
            this.company_name !== '' &&
            this.company_name !== null &&
            this.industry_type !== '' &&
            this.industry_type !== null &&
            this.work_contract_type !== '' &&
            this.work_contract_type !== null &&
            this.occupation_type !== '' &&
            this.occupation_type !== null
          );
        } else {
          return true;
        }
      }
    },
    getUniversityInputFlag(appUniversityId) {
      const appUniversity = this.m_university.find(
        (ele) => ele.id == appUniversityId
      );
      return appUniversity ? appUniversity.input_text_flag : 0;
    },

    getFacultyInputFlag(appFacultyId) {
      const appFaculty = this.m_faculty.find((ele) => ele.id == appFacultyId);
      return appFaculty ? appFaculty.input_text_flag : 0;
    },

    onchangeFaculty(event) {
      if (this.old_faculty_id == event.target.value) {
        this.faculty = this.old_faculty;
      } else {
        this.faculty = '';
      }
      const currentFaculty = this.m_faculty.find(
        (ele) => ele.id == Number(event.target.value)
      );
      this.faculty_input_text_flag = currentFaculty
        ? currentFaculty.input_text_flag
        : 0;
    },

    onchangeUniversity(event) {
      if (this.old_university_id == event.target.value) {
        this.school_name = this.old_school_name;
      } else {
        this.school_name = '';
      }
      const currentUniversity = this.m_university.find(
        (ele) => ele.id == Number(event.target.value)
      );
      this.university_input_text_flag = currentUniversity
        ? currentUniversity.input_text_flag
        : 0;
    },

    checkValidSchoolName() {
      if (this.school_name == '' && this.faculty_input_text_flag == 1) {
        this.requiredSchoolName = true;
      }
    },

    checkValidFacultyName() {
      if (this.faculty == '' && this.faculty_input_text_flag == 1) {
        this.requiredFacultyName = true;
      }
    },

    // ====================
    // FIELD CONFIGURATION METHODS
    // ====================
    isFieldRequired(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('required')) {
        return modification.required;
      }
      // Default required fields for display based on template type
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        const defaultRequired = [
          'study_status', 'university_id', 'faculty_id', 'graduation_month',
          'work_status', 'jlpt_level', 'english_level', 'expect_occupation_type',
          'work_location'
        ];
        if (this.work_status === WORK_STATUS_YES) {
          defaultRequired.push('company_name', 'industry_type', 'occupation_type', 'work_contract_type');
        }
        return defaultRequired.includes(fieldName);
      } else {
        const defaultRequired = [
          'last_academic_history', 'work_status_text', 'skill_name_text',
          'expect_occupation_type_text', 'expected_requirements', 'expected_pay',
          'work_location'
        ];
        return defaultRequired.includes(fieldName);
      }
    },

    isFieldReadonly(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      return modification ? modification.readonly : false;
    },

    getFieldDefaultValue(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      return modification && modification.default_value
        ? modification.default_value
        : '';
    },

    preventChangeIfReadonly(event, fieldName) {
      if (this.isFieldReadonly(fieldName)) {
        event.preventDefault();
      }
    },

    // Get validation rules for a field based on form modifications
    getFieldValidationRules(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('validation')) {
        return modification.validation;
      }
      // Default validation rules based on template type
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        const fieldRules = {
          study_status: [{type: 'required', pathTextLang: 'validate.required'}],
          university_id: [{type: 'required', pathTextLang: 'validate.required'}],
          faculty_id: [{type: 'required', pathTextLang: 'validate.required'}],
          graduation_month: [{type: 'required', pathTextLang: 'validate.required'}],
          work_status: [{type: 'required', pathTextLang: 'validate.required'}],
          jlpt_level: [{type: 'required', pathTextLang: 'validate.required'}],
          english_level: [{type: 'required', pathTextLang: 'validate.required'}],
          toeic_score: [{type: 'between', pathTextLang: 'validate.out-of-range'}],
          expect_occupation_type: [{type: 'required', pathTextLang: 'validate.required'}],
          work_location: [{type: 'required', pathTextLang: 'validate.required'}],
          company_name: [{type: 'maxLength', pathTextLang: 'validate.out-of-range'}],
          self_promotion: [{type: 'maxLength', pathTextLang: 'validate.out-of-range'}]
        };
        return fieldRules[fieldName] || [];
      } else {
        const fieldRules = {
          last_academic_history: [{type: 'required', pathTextLang: 'validate.required'}],
          work_status_text: [{type: 'required', pathTextLang: 'validate.required'}],
          skill_name_text: [
            {type: 'required', pathTextLang: 'validate.required'},
            {type: 'maxLength', pathTextLang: 'validate.out-of-range'}
          ],
          expect_occupation_type_text: [{type: 'required', pathTextLang: 'validate.required'}],
          expected_requirements: [{type: 'required', pathTextLang: 'validate.required'}],
          expected_pay: [{type: 'required', pathTextLang: 'validate.required'}],
          work_location: [{type: 'required', pathTextLang: 'validate.required'}]
        };
        return fieldRules[fieldName] || [];
      }
    },

    checkDateFormate(dateString) {
      const regex = this.$i18n.locale === LANG_CODE_JAPANESE
        ? /^\d{4}\/\d{1,2}\/\d{1,2}$/
        : /^\d{1,2}\/\d{1,2}\/\d{4}$/;
      return regex.test(dateString);
    },

    checkMonthFormate(dateString) {
      const regex = this.$i18n.locale === LANG_CODE_JAPANESE
        ? /^\d{4}\/\d{1,2}$/
        : /^\d{1,2}\/\d{4}$/;
      return regex.test(dateString);
    }
  }
};
</script>

<style lang="scss">
.left-column {
  min-width: 330px;
  display: flex;
  justify-content: flex-start;
}

.input-example-style {
  display: flex;
  margin-top: 0.5rem;
  white-space: pre-wrap;
}

.edit-input-style {
  width: 100%;
}

#select-option-style {
  margin-bottom: 0;
}

#add-input-style {
  margin: 32px 0 0 0;
}

.add-input-style {
  margin: 5px 0 0 0;
}
</style>
